import React from 'react';
import { Inbox, FileEdit, Clock, Send, LayoutTemplate, BarChart3, Trash2, PenSquare, Settings } from 'lucide-react';
import type { MarketingEmailFolder } from '../../../models/MasterAdmin/marketingEmail';
import { meComposeBtnClass, meNavItemClass, meSidebarClass } from './marketingEmailUi';

interface EmailSidebarProps {
  activeFolder: MarketingEmailFolder;
  onFolderChange: (folder: MarketingEmailFolder) => void;
  onCompose: () => void;
  counts: Partial<Record<MarketingEmailFolder, number>>;
}

const FOLDERS: { id: MarketingEmailFolder; label: string; icon: React.ReactNode }[] = [
  { id: 'all', label: 'All', icon: <Inbox className="h-4 w-4" /> },
  { id: 'drafts', label: 'Drafts', icon: <FileEdit className="h-4 w-4" /> },
  { id: 'scheduled', label: 'Scheduled', icon: <Clock className="h-4 w-4" /> },
  { id: 'sent', label: 'Sent', icon: <Send className="h-4 w-4" /> },
  { id: 'templates', label: 'Templates', icon: <LayoutTemplate className="h-4 w-4" /> },
  { id: 'analytics', label: 'Analytics', icon: <BarChart3 className="h-4 w-4" /> },
  { id: 'settings', label: 'Settings', icon: <Settings className="h-4 w-4" /> },
  { id: 'trash', label: 'Trash', icon: <Trash2 className="h-4 w-4" /> },
];

const EmailSidebar: React.FC<EmailSidebarProps> = ({ activeFolder, onFolderChange, onCompose, counts }) => (
  <aside className={meSidebarClass}>
    <button type="button" onClick={onCompose} className={meComposeBtnClass}>
      <PenSquare className="h-4 w-4" />
      Compose
    </button>

    <nav className="mt-5 flex flex-col gap-0.5 px-1" aria-label="Email folders">
      {FOLDERS.map((folder) => (
        <button
          key={folder.id}
          type="button"
          onClick={() => onFolderChange(folder.id)}
          className={meNavItemClass(activeFolder === folder.id)}
        >
          {folder.icon}
          <span className="flex-1 text-left">{folder.label}</span>
          {(counts[folder.id] ?? 0) > 0 && (
            <span className="rounded-full bg-gray-200 px-1.5 py-0.5 text-[10px] font-semibold text-gray-600 dark:bg-gray-700 dark:text-gray-300">
              {counts[folder.id]}
            </span>
          )}
        </button>
      ))}
    </nav>

      <div className="mt-auto border-t border-gray-200/80 p-4 dark:border-gray-800">
        <p className="text-[11px] leading-relaxed text-gray-400 dark:text-gray-500">
          Sends via Brevo transactional API. Analytics syncs live from Brevo.
        </p>
      </div>
  </aside>
);

export default EmailSidebar;
